module.exports = __webpack_public_path__ + "static/media/top-time-active-dark-icon.f8c11ba0.svg";